export default "__VITE_ASSET__Wqpznh$0__"